import { Fragment } from 'react';

import { numberRange } from 'utils/clickme';

import Gap from 'bloko/blocks/gap';

import useTrls from 'hooks/translation/useTrls';

import Table from 'components/Table';

import CrmActivity from 'components/Admin/CrmActivities/CrmActivity';
import TitlePage from 'components/Admin/TitlePage';
import TableBody from 'components/Table/TableBody';
import TableHead from 'components/Table/TableHead';
import TableHeadCell from 'components/Table/TableHeadCell';
import TableRow from 'components/Table/TableRow';

import { useSelector } from 'store/utils';

const HEADERS_RANGE = numberRange(0, 2);

const CrmActivities = () => {
    const activities = useSelector((state) => state.crmActivities);
    const trl = useTrls();

    return (
        <div>
            <TitlePage>{trl('admin.CrmActivities.title')}</TitlePage>
            <Gap top>
                <Table withStripes bordered fullWidth>
                    <TableHead>
                        <TableRow>
                            <TableHeadCell>{trl('admin.CrmActivities.Header.title')}</TableHeadCell>
                            <TableHeadCell colSpan={2}>{trl('admin.CrmActivities.Header.monthly')}</TableHeadCell>
                            <TableHeadCell colSpan={2}>{trl('admin.CrmActivities.Header.weekly')}</TableHeadCell>
                            <TableHeadCell colSpan={2}>{trl('admin.CrmActivities.Header.daily')}</TableHeadCell>
                            <TableHeadCell>{trl('admin.CrmActivities.Header.enabled')}</TableHeadCell>
                        </TableRow>
                        <TableRow>
                            <TableHeadCell />
                            {HEADERS_RANGE.map((item) => (
                                <Fragment key={item}>
                                    <TableHeadCell>{trl('admin.CrmActivities.Header.total')}</TableHeadCell>
                                    <TableHeadCell>{trl('admin.CrmActivities.Header.sent')}</TableHeadCell>
                                </Fragment>
                            ))}
                            <TableHeadCell />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {activities.map((activity) => (
                            <CrmActivity key={activity.crmActivityTypeId} {...activity} />
                        ))}
                    </TableBody>
                </Table>
            </Gap>
        </div>
    );
};

export default CrmActivities;
